export interface EventData {
  path: string;
  title: string;
  mobileTitle?: string;
  time: string;
  location: string;
  locationHref: string;
  description: string;
  attire: string;
  imgSrc: string;
}

export const events: EventData[] = [
  {
    path: '/events/drinks',
    title: 'Welcome Drinks',
    mobileTitle: 'Welcome',
    time: 'Friday, May 18, 7:30-10:00pm',
    location: 'Haleiwa Beach House',
    locationHref: 'https://goo.gl/maps/ktWjEnPxiZu',
    description: 'No reservation needed, just stop by the bar for a casual hangout.',
    imgSrc: `${process.env.PUBLIC_URL}/img/events_welcome.jpg`,
    attire: '',
  },
  {
    path: '/events/ceremony',
    title: 'Ceremony',
    time: 'Saturday, May 19, 4:30-5:00pm',
    location: 'Dillingham Ranch',
    locationHref: 'https://goo.gl/maps/JnHhNjTBWp62',
    description: 'A row of royal palms and our closest friends and family to help us say I do!',
    imgSrc: `${process.env.PUBLIC_URL}/img/events_ceremony.jpg`,
    attire: 'Summertime cocktail',
  },
  {
    path: '/events/reception',
    title: 'Reception',
    time: 'Saturday, May 19, 5:00-10:00pm',
    location: 'Dillingham Ranch',
    locationHref: 'https://goo.gl/maps/JnHhNjTBWp62',
    description:
      'Enjoy a cocktail or two with some passed pupus, then move out front to the lawn for dinner, and dancing under \
      the banyan trees.',
    imgSrc: `${process.env.PUBLIC_URL}/img/events_reception.jpg`,
    attire:
      'After that show of love, you may be tempted to de-robe just a little. Bow tie optional, dancing shoes required.',
  },
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/data/events.ts